import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { ScanContextProvider } from '../Scan/ScanContext';

const TemplatesContext = createContext({});

export const TemplatesContextProvider = ({ children }) => {
  return (
    <TemplatesContext.Provider value={{}}>
      {children}
    </TemplatesContext.Provider>
  )
};

ScanContextProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default () => useContext(TemplatesContext);
